<template>
    <Section 
        v-if="jumpLinks.length"
        :width="sectionWidth" 
        class="table-of-contents"
    >
        <Expander 
            :title="expanderButtonText"
        >
            <ul class="wrapper">
                <li 
                    v-for="(jumpLink, index) in jumpLinks"
                    :key="index"
                >
                    <a v-scroll-to="jumpLink.id" href="#" class="table-of-contents-link">
                        {{ jumpLink.linkText }}
                    </a>
                </li>
            </ul>
        </Expander>
    </Section>
</template>
<script>
import Expander from '@/components/Expander.vue';
export default {
    components: {
        Expander
    },
    props: {
        slice: {
            type: Object,
            required: true
        },
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        sectionWidth() {
            return this.slice.primary.slice_width ?? 'sm';
        },
        jumpLinks() {
            return this.slicesOnDocument
                .filter(slice => slice.slice_type === 'table_of_contents_link' && this.$validateText(slice.primary.link_text))
                .map(slice => {
                    return {
                        id: `#${this.$formatId(slice.id)}`,
                        linkText: slice.primary.link_text
                    };
                });
        },
        expanderButtonText() {
            return this.$validateText(this.slice.primary.expander_button_text) 
                ? this.slice.primary.expander_button_text 
                : this.$translate('table_of_contents_expander_button_text', 'Innehållsförteckning');
        },
        slicesOnDocument() {
            return this.document.data.body;
        },
    }
};
</script>
<style lang='scss' scoped>
    .table-of-contents::v-deep {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 40px;
        font-family: $fontText;

        @include device(pad) {
            margin-top: 48px;
        }

        .expander {
            .expander-button {
                display: flex;
                align-items: center;
                gap: .5rem;
                user-select: none;
                &.expanded {
                    .expander-title {
                        text-decoration: underline;
                    }
                }
            }
            .wrapper {
                display: flex;
                flex-direction: column;
                background-color: $lightgray;

                .table-of-contents-link {
                    display: block;
                    padding: .75rem .5rem;
                    @include border(left, 3px);
                    color: $font;
                    transition: .2s ease-in-out;
                    &:hover {
                        padding-left: 1rem;
                        border-color: $pink;
                    }
                }
            }
        }
    }
</style>